import React, { useEffect, useState } from "react";
import { ReactComponent as RightArrowIcon } from "../assets/images/right-arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviewData } from "../slices/trainingFormReviewSlice";
const Step = ({ node, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const selectedDepartment = useSelector(
    (state) => state.trainingFormReview.selectedDepartment
  );

  const dispatch = useDispatch();
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleFetchReviewData = (node) => {
    if (selectedDepartment != node.departmentId) {
      dispatch(fetchReviewData({departmentId : node.departmentId}));
    }
  };

  // Always open if defaultOpen changes (e.g., after reset)
  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <li className="font-semibold mt-2  2xl:text-base 2xl:leading-base text-sm leading-sm text-gray-700 mb-3 cursor-pointer">
      <div
        className={`flex items-center ${
          !node.sub_departments.length > 0 && "ml-5"
        }`}
      >
        {node.sub_departments.length > 0 && (
          <span
            className={`mr-2 transition-transform duration-200 ${
              isOpen ? "rotate-90" : ""
            }`}
            onClick={() => handleToggle()}
          >
            <RightArrowIcon className="w-4 h-4" />
          </span>
        )}
        <span
          onClick={() => handleFetchReviewData(node)}
          className={`${
            selectedDepartment == node.departmentId && "text-blue-500"
          }`}
        >
          {node.name}
        </span>
      </div>
      {isOpen && node.sub_departments.length > 0 && (
        <ul className="ml-3">
          {node.sub_departments.map((child) => (
            <Step
              key={child.id}
              node={child}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const Stepper = ({ data }) => {
  return (
    <>
      {data.map((node) => (
        <Step
          key={node.id}
          node={node}
          defaultOpen={true}
        />
      ))}
    </>
  );
};

export default Stepper;
